export const notificationsStyles = {
  NotificationItem: {
    // Override the notification item
    DefaultStyle: {
      // Applied to every notification, regardless of the notification level
      fontFamily: "Lato, Arial, sans-serif",
      margin: "100px 5px 2px 1px",
      isVisible: {
        opacity: "0.8",
      },
    },
    success: {
      // Applied only to the success notification item
      color: "#000",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "#FFF",
      WebkitBoxShadow: "none",
      MozBoxShadow: "none",
      boxShadow: "none",
      border: "1px solid #CCC",
      fontWeight: "bold",
    },
    error: {
      // Applied only to the error notification item
      color: "white",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "red",
      border: "none",
      WebkitBoxShadow: "none",
      MozBoxShadow: "none",
      boxShadow: "none",
    },
  },
  Dismiss: {
    DefaultStyle: {
      fontFamily: "Lato, Arial, sans-serif",
      fontSize: "14px",
      position: "absolute",
      top: "4px",
      right: "5px",
      lineHeight: "15px",
      backgroundColor: "#FFF",
      color: "white",
      border: 0,
      width: "14px",
      height: "14px",
      fontWeight: "bold",
      textAlign: "center",
    },
    success: {
      color: "#000",
    },
    error: {
      color: "white",
      backgroundColor: "red",
    },
  },
  Action: {
    DefaultStyle: {
      fontFamily: "Lato, Arial, sans-serif",
      backgroundColor: "white",
      borderRadius: "2px",
      padding: "6px 20px",
      fontWeight: "normal",
      margin: "10px 0 0 0",
      border: 0,
    },

    success: {
      color: "#000",
      textDecoration: "underline",
    },
  },
};

export const manageNotificationsStyles = {
  NotificationItem: {
    // Override the notification item
    DefaultStyle: {
      // Applied to every notification, regardless of the notification level
      fontFamily: "Lato, Arial, sans-serif",
      margin: "10px 5px 2px 1px",
      isVisible: {
        opacity: "0.8",
      },
    },
    success: {
      // Applied only to the success notification item
      color: "#000",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "#FFF",
      border: "1px solid #CCC",
      WebkitBoxShadow: "none",
      MozBoxShadow: "none",
      boxShadow: "none",
      marginTop: "80px",
      fontWeight: "bold",
    },
    error: {
      // Applied only to the error notification item
      color: "white",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "red",
      border: "none",
      WebkitBoxShadow: "none",
      MozBoxShadow: "none",
      boxShadow: "none",
      marginTop: "80px",
    },
  },
  Dismiss: {
    DefaultStyle: {
      fontFamily: "Lato, Arial, sans-serif",
      fontSize: "14px",
      position: "absolute",
      top: "4px",
      right: "5px",
      lineHeight: "15px",
      backgroundColor: "#FFF",
      color: "white",
      border: 0,
      width: "14px",
      height: "14px",
      fontWeight: "bold",
      textAlign: "center",
    },
    success: {
      color: "#000",
    },
    error: {
      color: "white",
      backgroundColor: "red",
    },
  },
  Action: {
    DefaultStyle: {
      fontFamily: "Lato, Arial, sans-serif",
      backgroundColor: "white",
      borderRadius: "2px",
      padding: "6px 20px",
      fontWeight: "normal",
      margin: "10px 0 0 0",
      border: 0,
    },

    success: {
      backgroundColor: "#000",
      textDecoration: "underline",
    },
  },
};

export const autosuggestTheme = {
  container: {
    display: "inline-block",
    width: "100%",
    zIndex: "3",
    position: "relative",
    fontFamily: "Lato",
  },
  input: {
    padding: "10px",
    // border: 'none',
    border: "solid 1px #c9c9c9",
    borderRadius: "4px",
    width: "100%",
    height: "35px",
    fontSize: "16px",
  },
  inputFocused: {
    outline: "none",
  },
  suggestionsContainerOpen: {
    display: "block",
    border: "1px solid lightGrey",
    padding: "10px",
    maxHeight: "300px",
    overflowY: "scroll",
    backgroundColor: "#FFF",
    position: "absolute",
    zIndex: "1000",
    width: "100%",
  },
  suggestionsList: {
    margin: "0",
    padding: "0",
    listStyleType: "none",
  },
  suggestion: {
    cursor: "pointer",
    padding: "5px 15px",
  },
  suggestionHighlighted: {
    backgroundColor: "#ddd",
  },
};

export const invitationModalAutosuggestTheme = {
  container: {
    display: "inline-block",
    width: "83%",
    zIndex: "3",
    position: "relative",
    fontFamily: "Lato",
    height: "calc(1.5em + .75em + 2px)",
    marginBottom: "16px",
  },
  input: {
    padding: ".500em .75em",
    border: "solid 1px #c9c9c9",
    borderRadius: "4px",
    width: "100%",
  },
  inputFocused: {
    outline: "none",
  },
  suggestionsContainerOpen: {
    display: "block",
    border: "1px solid lightGrey",
    padding: "10px",
    maxHeight: "300px",
    overflowY: "scroll",
    backgroundColor: "#FFF",
    position: "absolute",
    zIndex: "1000",
    width: "100%",
  },
  suggestionsList: {
    margin: "0",
    padding: "0",
    listStyleType: "none",
  },
  suggestion: {
    cursor: "pointer",
    padding: "5px 15px",
  },
  suggestionHighlighted: {
    backgroundColor: "#ddd",
  },
};
